import {connect} from "react-redux";
import HelpComponent from "../../components/HelpComponent";

const stateToProps = (state) => {
    return {
        employeeInfo:state.login.employeeInfo,
    }
};
const dispatchToProps = (dispatch) => {
    return {
        dispatch:dispatch
    }
};


const Help = connect(stateToProps,dispatchToProps)(HelpComponent);
export default Help;
